import React from "react";
import styled from "styled-components";

const Astronaut = () => {
  return (
    <div className="astro-container">
      <div className="astronaut">
        <div className="tank center"></div>
        <div className="suit center">
          <div className="helmet center"></div>
          <div className="buttons center"></div>
          <div className="hand-l"></div>
          <div className="hand-r"></div>
          <div className="leg-l"></div>
          <div className="leg-r"></div>
          <div className="pipe"></div>
        </div>
      </div>
    </div>
  );
};

export default Astronaut;
